/* eslint func-style: "off" */
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import * as actions from './AdminManagement.slice';
import get from 'lodash/get';

import apiClient from 'helpers/apiClient';

export const getProfile = (state) => state.AdminManagement.profile;

export const searchProfile = function* ({payload: profileId}) {
  try {
    const profile  = yield call(apiClient, '/api/profiles/search-deleted', {
      method: 'POST',
      body: JSON.stringify({ profileId })
    });
    yield put(actions.searchProfileSucceeded(profile));
  } catch (e) {
    const error = get(e, 'body.error', 'There was a problem finding the Workspace/Dataset');
    yield put(actions.searchProfileFailed(error));
  }
};

export const undeleteProfile = function* () {
  try {
    const profile = yield select(getProfile);
    const profileId = profile._id.toString();
    const param = profile.type === 'Campaign' ? 'campaigns' : 'profiles';
    const fieldName = profile.type === 'Campaign' ? 'campaignId' : 'profileId';
    const body = { [fieldName]: profileId };
    const response  = yield call(apiClient, `/api/${param}/undelete`, {
      method: 'POST',
      body: JSON.stringify(body)
    });
    yield put(actions.undeleteProfileSucceeded(response));
  } catch (e) {
    yield put(actions.undeleteProfileFailed(e));
  }
};


export const searchProfileSaga = function* () {
  yield takeLatest(actions.searchProfile.type, searchProfile);
};

export const undeleteProfileSaga = function* () {
  yield takeLatest(actions.undeleteProfile.type, undeleteProfile);
};


const sagas = function* () {
  yield all([
    fork(searchProfileSaga),
    fork(undeleteProfileSaga)
  ]);
};

export default sagas;
